module.exports = __webpack_public_path__ + "static/image_meta-0aede06e70f09bebb44d1bd650a646bc.jpg";